export const PARAGRAPHS = [
  {
    id: 1,
    text: "This area allows you to select the reports which you what to compare. Select the report from the left hand side of the page and then select the other report from the right hand side that you wish to compare. The reports will then compile and be viewable to you to review and print.",
  },
];
